<template>
  <section class="customcheckerboard-main-views-wrapper">
    <base-spinner
      :set-spinner-default="true"
      classes="spinner"
      position="absolute">
    </base-spinner>
    <div v-show="false">
      <checkerboard-fabric-canvas :key="fabricCanvasComponentKey"
        :tileConfig="tileConfig"
        :color1="canvasConfig.color1"
        :color2="canvasConfig.color2"
        ref="canvasImage"
      ></checkerboard-fabric-canvas>
      <img v-for="component in components" :key="`warpImage${component}`" :ref="`warpImage${component}`">
    </div>
    <component
      :is="activeView"
      v-bind="$attrs"
      :canvasLoaded="isCanvasLoaded"
      @sizeSelected="sizeSelected"
      @setCanvasLoaded="setCanvasLoaded"
      @generateCanvas="generateCanvas"
    ></component>
  </section>
</template>

<script>
import checkerboardColorSelector from '@/components/CustomCheckerboard/MainViews/ColorSelector';
import checkerboardSizeSelector from '@/components/CustomCheckerboard/MainViews/SizeSelector';
import checkerboardStyleSelector from '@/components/CustomCheckerboard/MainViews/StyleSelector';
import checkerboardWarpSelector from '@/components/CustomCheckerboard/MainViews/WarpSelector';
import checkerboardAlmostDone from '@/components/CustomCheckerboard/MainViews/AlmostDone';
import checkerboardConfirmDesign from '@/components/CustomCheckerboard/MainViews/ConfirmDesign';
import checkerboardFabricCanvas from '@/components/CustomCheckerboard/FabricCanvas/CheckerboardFabricCanvas';
import baseSpinner from '@/components/Spinner';


export default {
  name: "mainViews",
  components: {
    checkerboardColorSelector,
    checkerboardSizeSelector,
    checkerboardWarpSelector,
    checkerboardConfirmDesign,
    checkerboardFabricCanvas,
    checkerboardStyleSelector,
    checkerboardAlmostDone,
    baseSpinner
  },
  data() {
    return {
      isSizeSelected: false,
      isCanvasLoaded: false,
      tileConfig: {},
      fabricCanvasComponentKey: null,
      hideSpinner: true,
      components: []
    }
  },
  computed: {
    activeView() {
      return this.$store.state.customCheckerboard.navigation.activeView;
    },
    canvasConfig() {
      return this.$store.state.customCheckerboard.canvasConfig;
    },
    enableControls() {
      return this.$store.state.customCheckerboard.enableControls;
    }
  },
  watch: {
    enableControls(newValue) {
      this.$eventBus.$emit("hide-customs-spinner", newValue);
    }
  },
  methods: {
    sizeSelected(config) {
      // This is useful when the modal is closed in the checkerboard size component
      // At this point the refs are undefined.
      if (!this.getCheckerboardCanvas()) return;
      this.setCanvasLoaded(false);
      this.tileConfig = config;
      const { color1, color2, size } = this.canvasConfig;
      this.fabricCanvasComponentKey = `${color1}${color2}${size}`;
      this.$nextTick(() => {
        const image = new Image();
        image.onload = () => {
          if (this.$store.state.customCheckerboard.skipWarpSelector) {
            // In case it's precreated with other warpSelector
            // it ensures that the value will be noWarp
            this.$store.commit('customCheckerboard/SET_CANVAS_CONFIG', { warp: 'noWarp' });
            this.$store.commit('customCheckerboard/SET_COMPONENT_CONFIG', {
              component: this.$store.state.customCheckerboard.activeUGCComponent || "",
              canvasConfig: this.canvasConfig
            });
          }

          this.getCheckerboardCanvas().toBlob((blob) => {
            this.getWarpImage().src = URL.createObjectURL(blob);
            this.setCanvasLoaded(true);
          });
        }
        this.getCheckerboardCanvas().toBlob((blob) => {
          image.src = URL.createObjectURL(blob);
        });

      });
    },
    getCheckerboardCanvas() {
      return this.$refs.canvasImage && this.$refs.canvasImage.$refs.checkerboardFabricCanvas;
    },
    getWarpImage() {
      const { activeUGCComponent : activeComponent} = this.$store.state.customCheckerboard;
      return this.$refs[`warpImage${activeComponent || ""}`][0]
    },
    /**
     * @function setCanvasLoaded
     * Save the value for isCanvasLoaded variable.
     * It is passed as prop to the child component. Once the canvas is loaded
     * the child component will be able to render the warpsGlfx components.
     */
    setCanvasLoaded(value) {
      this.isCanvasLoaded = value;
    },
    getCheckerboardComponents() {
      const componentsCheckerboard = this.$store.getters['ugc/getUGCEnabledComponents'];
      this.components = componentsCheckerboard.length > 0 ? componentsCheckerboard : [""];
    },
    /**
     * @function generateCanvas
     * Generates canvas when the config has changed.
     * Currently, is just used when the user goes back from new checkerboard
     * for the second component. When the users goes until size/warp selector
     * the canvas must have the config from the first component.
     */
    generateCanvas() {
      const { color1, color2, size } = this.canvasConfig;
      this.fabricCanvasComponentKey = `${color1}${color2}${size}`;
    }
  },
  created () {
    this.getCheckerboardComponents();
  },
  provide() {
    return {
      canvasImage: this.getCheckerboardCanvas,
      wrapImage: this.getWarpImage
    }
  }
}
</script>
